export default [
  {
    path: '/receivables',
    name: 'Receivables',
    component: () => import('@/layout'),
    redirect: '/receivables/receive',
    meta: {
      title: '收付款管理',
    },
    children: [
      {
        path: 'sub-account-manage',
        name: 'subAccountManageList',
        component: () => import('@/views/web/receivables/sub-account-manage/list'),
        meta: {
          title: '分账单管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-15',
          trackName: '收付款管理 - 分账单管理',
          activeMenu: '/receivables/sub-account-manage',
        },
      },
      {
        path: 'receive',
        name: 'ReceivablesReceiveList',
        component: () => import('@/views/web/receivables/receive/list'),
        meta: {
          title: '应收单管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-16',
          trackName: '收付款管理 - 应收单管理',
          activeMenu: '/receivables/receive',
        },
      },
      {
        path: 'receipt',
        name: 'ReceivablesReceiptList',
        component: () => import('@/views/web/receivables/receipt/list'),
        meta: {
          title: '收款单管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-17',
          trackName: '收付款管理 - 收款单管理',
          activeMenu: '/receivables/receipt',
        },
      },
      {
        path: 'payment-payable',
        name: 'paymentPayableList',
        component: () => import('@/views/web/receivables/payment-payable/list'),
        meta: {
          title: '应付单管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-18',
          trackName: '收付款管理 - 应付单管理',
          activeMenu: '/receivables/payment-payable',
        },
      },
      {
        path: 'payment',
        name: 'paymentList',
        component: () => import('@/views/web/receivables/payment/list'),
        meta: {
          title: '付款单管理',
          noCache: false,
          auth: true,
          trackCode: 'menu-19',
          trackName: '收付款管理 - 付款单管理',
          activeMenu: '/receivables/payment',
        },
      },
    ],
  },
];
